<!-- eslint-disable vue/no-v-html -->
<template>
  <SelectList
    v-model="selectedValue"
    :clearable="clearable"
    dense
    :display-value="displayValue"
    emit-value
    filled
    :label="label"
    map-options
    :multiple="multiple"
    :option-label="optionLabel"
    option-value="id"
    :options="teamOptions"
    square
  >
    <StreemTooltip v-if="multiple">
      <span v-html="tooltipText" />
    </StreemTooltip>
  </SelectList>
</template>

<script>
import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "TeamDropdown",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    hideDefault: {
      type: Boolean,
    },
    multiple: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
    label: {
      type: String,
      default: "Select Team",
    },
    optionLabel: {
      type: String,
      default: "label",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    selectedValue: {
      get() {
        if (this.multiple && this.modelValue) {
          return this.modelValue.map((val) => val.toString());
        }

        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    teamOptions() {
      const defaultOption = { id: null, [this.optionLabel]: "None" };

      return this.hideDefault
        ? this.options
        : [defaultOption].concat(this.options);
    },
    tooltipText() {
      return this.teamOptions
        .filter((team) => this.selectedValue.includes(team.id))
        .map((team) => team.name)
        .join("<br>");
    },
    displayValue() {
      if (
        !this.multiple ||
        !this.selectedValue ||
        this.selectedValue.length === 0
      ) {
        return null;
      }

      const firstTeam = this.teamOptions.find(
        (team) => team.id === this.selectedValue[0]
      );

      if (this.selectedValue.length === 1) return firstTeam.name;

      return `${firstTeam.name} +${this.selectedValue.length - 1}`;
    },
  },
};
</script>
